export function formatPlayDuration({ playTimeInSeconds }: { playTimeInSeconds: number }) {
  const totalSeconds = playTimeInSeconds ?? 0;
  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = Math.floor(totalSeconds % 60);
  let playTime = '';

  if (h > 0) {
    playTime = `${h}h `;
  }
  if (m > 0) {
    playTime += `${m}m `;
  }
  if (s > 0 && h == 0) {
    playTime += `${s}s`;
  }

  return playTime.trim();
}
